const MIN_TRADING_DAYS_REQUIRED = 36;

const getPayoutAlertBadges = (alerts, { showBelowMinTradingDays = false } = {}) => {
    if (!alerts) return [];

    const badges = [];

    if (alerts.tradeOver30PctTotalPnL) {
        badges.push({
            key: 'tradeOver30PctTotalPnL',
            label: '>30% PnL',
            title: 'Largest win is at least 30% of total account P/L (positive P/L only).'
        });
    }

    if (alerts.lowRolling10DayAvg) {
        badges.push({
            key: 'lowRolling10DayAvg',
            label: '<2 Trades/10d',
            title: '10-day rolling average trades per day is below 2.'
        });
    }

    if (showBelowMinTradingDays && alerts.belowMinTradingDays) {
        const daysTraded = Number(alerts.totalDaysTraded) || 0;
        badges.push({
            key: 'belowMinTradingDays',
            label: '<36 Days',
            title: `Only ${daysTraded} distinct trading day(s) in the program period; minimum ${MIN_TRADING_DAYS_REQUIRED} required for the 90-day funded term.`
        });
    }

    if (Array.isArray(alerts.stocksBelow5) && alerts.stocksBelow5.length > 0) {
        const tickers = alerts.stocksBelow5.map((row) => row.symbol).join(', ');
        badges.push({
            key: 'stocksBelow5',
            label: 'Below $5',
            title: `Traded stock(s) below $5: ${tickers}`
        });
    }

    return badges;
};

export default getPayoutAlertBadges;
